import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { InputNumberComponent } from '../components/input-number/input-number.component';

/**
 * @description 驗證 primeng input number 組件輸入值是否大於等於指定數值，
 * 錯誤訊息 key 值為 sigvNumberInputMinValidator
 */
@Directive({
  selector: '[sigvNumberInputMinValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NumberInputMinValidatorDirective,
      multi: true,
    },
  ],
})
export class NumberInputMinValidatorDirective implements Validator {
  @Input()
  sigvNumberInputMinValidator?: number | null;
  constructor(private inputNumber: InputNumberComponent) {}

  validate(): ValidationErrors | null {
    if (
      this.inputNumber &&
      this.inputNumber.value !== null &&
      this.sigvNumberInputMinValidator
    ) {
      return this.inputNumber.value >= this.sigvNumberInputMinValidator
        ? null
        : { sigvNumberInputMinValidator: true };
    }
    return null;
  }
}
